import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import PackageList from './PackageCard';

const Packages = () => {
    const [data, setData] = useState({
        tripType: 'OW', // or 'RT'
        from: '',
        to: '',
        pickupdate: '',
        pickuptime: '',
        returndate: '',
    });

    return (
        <Box p={6}>
            <PackageList
                fromLocation={data.from}
                toLocation={data.to}
                pickupDate={data.pickupdate}
                pickupTime={data.pickuptime}
                returnDate={data.returndate}
                tripType={data.tripType}
            />
        </Box>
    );
};

export default Packages;